
import project3 from '../../images/project-3.png';
import project4 from '../../images/project-4.png';
import project5 from '../../images/project-5.png';
import project6 from '../../images/project-6.png';
import project7 from '../../images/project-7.png';
import project8 from '../../images/project-8.png';
import project9 from '../../images/project-9.png';
import project10 from '../../images/project-10.png';
import project11 from '../../images/project-11.png';
import project12 from '../../images/project-12.png';
import project13 from '../../images/project-13.png';

const projects = [
  {
    imgSrc: project13,
    alttext: 'Trade Villa',
    name: 'Trade Villa',
    language: 'React Js | Node Js | MongoDB',
    github: 'https://github.com/Ahsanul-kabir/trade-villa-client',
    live: 'https://trade-villa.web.app/'
  },
  // {
  //   imgSrc: project12,
  //   alttext: 'Krrishir Kotha',
  //   name: 'Krrishir Kotha',
  //   language: 'React Js | Node Js | MongoDB',
  //   github: 'https://github.com/Ahsanul-kabir/krrishir-kotha-client',
  //   live: 'https://krrishir-kotha.web.app/'
  // },
  {
    imgSrc: project11,
    alttext: 'Cycle Zone site',
    name: 'Cycle Zone',
    language: 'React Js | Node Js | MongoDB',
    github: 'https://github.com/Ahsanul-kabir/cycle-zone-client',
    live: 'https://cycle-zone-77.web.app/'
  },
  {
    imgSrc: project10,
    alttext: 'Hungry Mart',
    name: 'Hungry Mart',
    language: 'React Js',
    github: 'https://github.com/Ahsanul-kabir/hungry-mart',
    live: 'https://hungry-mart-e426b.web.app/'
  },
  {
    imgSrc: project9,
    alttext: 'Books Hub',
    name: 'Books Hub',
    language: 'React Js',
    github: 'https://github.com/Ahsanul-kabir/books-hub',
    live: 'https://books-hub-77.netlify.app/'
  },
  {
    imgSrc: project8,
    alttext: 'Mobile City',
    name: 'Mobile City',
    language: 'React Js',
    github: 'https://github.com/Ahsanul-kabir/mobile-city',
    live: 'https://mobile-city-77.netlify.app/'
  },
  {
    imgSrc: project7,
    alttext: 'Phone Mart',
    name: 'Phone Mart',
    language: 'Javascript',
    github: 'https://github.com/Ahsanul-kabir/phone-mart',
    live: 'https://phone-mart-77.netlify.app/'
  },
  {
    imgSrc: project6,
    alttext: 'Money Guru',
    name: 'Money Guru',
    language: 'Javascript',
    github: 'https://github.com/Ahsanul-kabir/money-guru',
    live: 'https://money-guru.netlify.app/'
  },
  {
    imgSrc: project5,
    alttext: 'Galaxy Convention',
    name: 'Galaxy Convention',
    language: 'Bootstrap',
    github: 'https://galaxy-convention.netlify.app/',
    live: 'https://galaxy-convention.netlify.app/'
  },
  {
    imgSrc: project4,
    alttext: 'TopCon Fashion',
    name: 'TopCon Fashion',
    language: 'Tailwind css',
    github: 'https://github.com/Ahsanul-kabir/TopCon-Fashion',
    live: 'https://ahsanul-kabir.github.io/TopCon-Fashion/'
  },
  {
    imgSrc: project3,
    alttext: 'Tackle Catalyst',
    name: 'Tackle Catalyst',
    language: 'Raw CSS',
    github: 'https://github.com/Ahsanul-kabir/tackle-catalyst/tree/main/tackle-catalyst',
    live: 'https://ahsanul-kabir.github.io/tackle-catalyst/tackle-catalyst/'
  },
];

export default projects;